module.exports = __webpack_public_path__ + "static/media/reward-point-icon.74f27146.svg";